
import React from "react";

interface WordErrorDisplayProps {
  errorMessage: string;
}

export const WordErrorDisplay: React.FC<WordErrorDisplayProps> = ({ 
  errorMessage 
}) => {
  return (
    <div className="text-red-500 w-full text-center animate-fadeIn">
      {errorMessage}
    </div>
  );
};
